import { types } from "../action-types";

const initialState = {
  loading: false,
  userTag: null,
  error: false,
};

const TagReduer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_USER_TAG_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case types.FETCH_USER_TAG_SUCCESS:
      return {
        ...state,
        loading: false,
        userTag: action.payload,
        error: false,
      };

    case types.FETCH_USER_TAG_FAILURE:
      return {
        ...state,
        loading: false,
        userTag: null,
        error: true,
      };

    default:
      return state;
  }
};

export default TagReduer;
